export default __webpack_public_path__ + "static/media/SpecialExitBenefit.66152dc1.png";